import { GraphQLClient } from "graphql-request";
import Cookies from 'js-cookie'

const graphQLClient = new GraphQLClient(`${process.env.REACT_APP_BASE_URL}/graphql`);

export const getGraphQLClient = () => {
  graphQLClient.setHeader('X-CSRFToken', Cookies.get('csrftoken'));
  return graphQLClient;
};
